import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { setNavigate, setLocation } from 'APP/router/refs/refs';

export function useNavigationHandlerPresenter(): void {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    setLocation(location);
  }, [location]);
}
